import React, {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import {useTranslation} from "react-i18next";
import {useDispatch} from "react-redux";
import Button from "../../../../components/Common/Button";
import {ContentType} from "../../../../db/models/content";
import {openAlert} from "../../../../slices/alert";
import {closeDialog} from "../../../../slices/dialog";
import {getUid} from "../../../../api/auth";
import {deleteContentDocAndMedia, updateContent, updateContentDocAndMedia,} from "../../../../api/content";

interface Props {
    video: ContentType;
}

export const UpdateVideo: React.FC<Props> = ({video}) => {
    const {register, handleSubmit, errors} = useForm({
        defaultValues: {
            title: video?.title,
            file: null,
        },
    });
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const [running, setRunning] = useState(false);

    const onUpdate = (form) => {
        const file = form.file?.[0];

        setRunning(true);

        const updatedContent = {
            ...video,
            title: form.title,
        };

        if (file) {
            updateContentDocAndMedia(form.file[0], updatedContent)
                .then(() => {
                    setRunning(false);
                    dispatch(
                        openAlert({type: "success", message: t("alert_video_uploaded")})
                    );
                    dispatch(closeDialog());
                })
                .catch((error) => {
                    console.error(error);
                    setRunning(false);
                    dispatch(
                        openAlert({type: "error", message: t("alert_generic_error")})
                    );
                });
        } else {
            updateContent(updatedContent)
                .then(() => {
                    setRunning(false);
                    dispatch(
                        openAlert({type: "success", message: t("alert_video_uploaded")})
                    );
                    dispatch(closeDialog());
                })
                .catch((error) => {
                    console.error(error);
                    setRunning(false);
                    dispatch(
                        openAlert({type: "error", message: t("alert_generic_error")})
                    );
                });
        }
    };

    const onDelete = () => {
        const uid = getUid();
        if (!uid || !video) return;

        setRunning(true);
        deleteContentDocAndMedia(uid, video.id)
            .then(() => {
                setRunning(false);
                dispatch(
                    openAlert({type: "success", message: t("alert_video_uploaded")})
                );
                dispatch(closeDialog());
            })
            .catch((error) => {
                console.error(error);
                setRunning(false);
                dispatch(
                    openAlert({type: "error", message: t("alert_generic_error")})
                );
            });
    };

    useEffect(() => {
        if (!video) {
            dispatch(closeDialog());
            return;
        }
    }, [video]);

    return (
        <div className="adminTest">
            <form onSubmit={handleSubmit(onUpdate)}>
                <fieldset disabled={running}>
                    <div className="element">
                        <div className="label">{t("company_addVideo_title_label")}</div>
                        <input
                            type="text"
                            name="title"
                            ref={register({required: true})}
                            placeholder={t("company_addVideo_title_ph")}
                        />
                        {errors.title && (
                            <p className="error">{t("company_addVideo_title_error")}</p>
                        )}
                    </div>
                    <div className="element">
                        <div className="label">File</div>
                        <input type="file" accept=".mp4" name="file" ref={register()}/>
                        {errors.file && (
                            <p className="error">{t("company_addVideo_file_error")}</p>
                        )}
                    </div>
                    {/* <Button type="submit" disabled={running}>
						Save
					</Button> */}
                </fieldset>
            </form>
            <Button disabled={running} onClick={onDelete}>
                Cancella
            </Button>
        </div>
    );
};
